import React from "react";

import { Link } from "react-router-dom";

class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArtistNav: false,
    };
  }
  toggleArtistsNav() {
    if (this.state.showArtistNav) {
      this.setState({ showArtistNav: false });
    } else {
      this.setState({ showArtistNav: true });
    }
  }

  render() {
    return (
      <nav>
        <ul id="main-nav">
          <li>
            <Link to={`${process.env.PUBLIC_URL}/artists/directors`}>
              Directors{" "}
            </Link>
          </li>
          <li>
            <Link to={`${process.env.PUBLIC_URL}/artists/photographers`}>
              Photographers
            </Link>
          </li>
          <a
            href={`
            https://estelleleeds.slateapp.com/showreel/shared/6a7b3427a1c35`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Multi Talent Reel
          </a>
          <li>
            <Link to={`${process.env.PUBLIC_URL}/clients`}>Clients </Link>
          </li>
          <li>
            <Link to={`${process.env.PUBLIC_URL}/biography`}>Biography </Link>
          </li>
          <li>
            <Link to={`${process.env.PUBLIC_URL}/contact`}>
              Contact / Production Collaborators{" "}
            </Link>
          </li>
        </ul>
      </nav>
    );
  }
}

export default Nav;
